export default "__VITE_ASSET__DtXj8xM9__"